// internal
import { axios, def, handleError, handleResponse } from './internal';

// state
import { storage } from '@goldblack/client-storage';

function ProfileChangePassword(password) {
    axios
        .post('/api/profile_change_password', {
            password: password,
        })
        .then((res) => {
            switch (res.data.code) {
                case def.ErrorCode.OK:
                    storage.transience.setState('path.settingAccount', '/');
                    storage.transience.setState('internal.success', 'Your password has been updated.');
                    break;
                default:
                    handleResponse(res);
                    break;
            }
        })
        .catch((err) => {
            handleError(err);
        });
}

export { ProfileChangePassword };
